import _ from 'lodash';

function trackID(value) {
    const isValid = _.isString(value) && _.size(value.split('-')) <= 2;
    if (!isValid) {
        console.warn(
            `trackID "${value}" is invalid -- must be in the format "the_screen_name-event_name" / "the_screen_name`
        );
    }
    return isValid;
}

function stringOrNull(value) {
    const isValid = _.isString(value) || _.isNull(value);
    if (!isValid) {
        console.warn(`stringOrNull "${value}" is invalid -- must be either a string or null`);
    }
    return isValid;
}

function numberOrNull(value) {
    const isValid = _.isNumber(value) || _.isNull(value);
    if (!isValid) {
        console.warn(`numberOrNull "${value}" is invalid -- must be either a number or null`);
    }
    return isValid;
}

function booleanOrNull(value) {
    const isValid = _.isBoolean(value) || _.isNull(value);
    if (!isValid) {
        console.warn(`booleanOrNull "${value}" is invalid -- must be either a boolean or null`);
    }
    return isValid;
}

function functionOrNull(value) {
    const isValid = _.isFunction(value) || _.isNull(value);
    if (!isValid) {
        console.warn(`functionOrNull "${value}" is invalid -- must be either a function or null`);
    }
    return isValid;
}

function arrayOrNull(value) {
    const isValid = _.isArray(value) || _.isNull(value);
    if (!isValid) {
        console.warn(`arrayOrNull "${value}" is invalid -- must be either an array or null`);
    }
    return isValid;
}

function objectOrNull(value) {
    const isValid = (_.isObject(value) && !_.isArray(value)) || _.isNull(value);
    if (!isValid) {
        console.warn(`objectOrNull "${value}" is invalid -- must be either an object or null`);
    }
    return isValid;
}

// eslint-disable-next-line import/prefer-default-export
export const lsPropTypeHelpers = {
    trackID,
    stringOrNull,
    numberOrNull,
    booleanOrNull,
    functionOrNull,
    arrayOrNull,
    objectOrNull,
};
